import { render, staticRenderFns } from "./camera-icon.vue?vue&type=template&id=74fe1df4&scoped=true&"
import script from "./camera-icon.vue?vue&type=script&lang=js&"
export * from "./camera-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fe1df4",
  null
  
)

export default component.exports